import { WcDatepicker } from 'wc-datepicker/dist/components/wc-datepicker';
customElements.define('wc-datepicker', WcDatepicker);

const formatDate = (date: Date) => {
	return date.toLocaleDateString('sv-SE', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});
};

const createDatepicker = (element: HTMLElement) => {
	const picker = document.querySelector('wc-datepicker');
	if (!picker) {
		console.error('Datepicker not found');
		return;
	}

	const form = element.closest('form');

	const button = element.querySelector<HTMLElement>('[data-datepicker-button]');
	const arrivalDateElement = element.querySelector<HTMLElement>(
		'[data-arrival-date]',
	);
	const departureDateElement = element.querySelector<HTMLElement>(
		'[data-departure-date]',
	);

	const arrivalDateInput = form?.querySelector<HTMLInputElement>(
		'#edit-arrivaldate',
	);
	const departureDateInput = form?.querySelector<HTMLInputElement>(
		'#edit-departuredate',
	);

	picker.disableDate = (date: Date) => {
		return date < new Date();
	};

	picker.labels = {
		clearButton: 'Töm värde',
		monthSelect: 'Välj månad',
		nextMonthButton: 'Nästa månad',
		nextYearButton: 'Nästa år',
		picker: 'Välj datum',
		previousMonthButton: 'Föregående månad',
		previousYearButton: 'Föregående år',
		todayButton: 'Visa idag',
		yearSelect: 'Välj år',
	};

	const open = () => {
		picker.style.removeProperty('display');
		picker.focus();
	};

	const close = (preventMoveFocus = false) => {
		picker.style.setProperty('display', 'none');
		if (!preventMoveFocus) {
			button?.focus();
		}
	};

	const toggle = () => {
		if (picker.style.display === 'none') {
			open();
		} else {
			close();
		}
	};

	picker.style.setProperty('display', 'none');

	button?.addEventListener('click', () => {
		toggle();
	});

	picker.addEventListener('selectDate', event => {
		if (!Array.isArray(picker.value)) {
			return;
		}

		let [arrivalDate, departureDate] = picker.value;

		if (arrivalDateElement && departureDateElement) {
			departureDate = departureDate ?? arrivalDate;

			arrivalDateElement.textContent = formatDate(arrivalDate);
			departureDateElement.textContent = formatDate(departureDate);

			arrivalDateElement.classList.remove('form-control--placeholder');
			departureDateElement.classList.remove('form-control--placeholder');
		}

		arrivalDateInput?.setAttribute('value', formatDate(arrivalDate));
		departureDateInput?.setAttribute('value', formatDate(departureDate));

		if (arrivalDate !== departureDate) {
			picker.style.setProperty('display', 'none');
		}
	});

	window.addEventListener('click', event => {
		if (element.contains(event.target as Node)) {
			return;
		}

		close(true);
	});

	window.addEventListener('keydown', event => {
		if (event.key === 'Escape') {
			close();
		}
	});
};

const element = document.querySelector<HTMLElement>('[data-datepicker]');
if (element) {
	createDatepicker(element);
}
